module.exports = __webpack_public_path__ + "img/send.9a23ff74.svg";